import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import MainButton from '@/components/ui/custom/buttons/MainButton';
import useAuth from '@/data/hook/useAuth';
import { isStaff } from '@/functions/auth';
import { Project } from '@/models/Project';
import { ROUTES } from '@/utils/routes';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { LEI_FELCA } from '@/lib/growthbook';
import { PencilIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const ProjectEdit = ({ project }: { project: Project }) => {
  const isLeiFelca = useFeatureIsOn(LEI_FELCA);
  const { user } = useAuth();
  const { t } = useTranslation('translation', {
    keyPrefix: 'projects.view',
  });
  const navigate = useNavigate();

  const onEdit = () =>
    navigate(ROUTES.PROJECTS.EDIT.INFO(project.id), {
      state: project,
    });
  return (
    <ConditionalRenderer condition={!isLeiFelca || isStaff(user?.userType)}>
      <MainButton
        onClick={onEdit}
        icon={<PencilIcon className="w-4 h-4" />}
        color="primary"
        text={t('editProject')}
      />
    </ConditionalRenderer>
  );
};

export default ProjectEdit;
